"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPTransport = void 0;
var HTTPTransport = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    function HTTPTransport(formatter, logBaseUrl) {
        this.formatter = formatter;
        this.logBaseUrl = logBaseUrl;
    }
    HTTPTransport.prototype.write = function (appLog) {
        var log = this.formatter.format(appLog);
        return fetch(this.logBaseUrl, {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify({ error: log }),
        }).catch(function (err) { return console.error(err); });
    };
    return HTTPTransport;
}());
exports.HTTPTransport = HTTPTransport;
//# sourceMappingURL=HTTPTransport.js.map